import { useQuery } from "@tanstack/react-query";
import { useUrlBuilder } from "apps/commons/hooks/useUrlBuilder";
import { TanstackQueryKey } from "apps/commons/tanstackQueryKey";
import type { AxiosError } from "axios";
import { oneOnboardingApi } from "libs/api";
import { useParams } from "router";
import { useStaticDataAtomState } from "./staticDataAtom";

export const useStaticDataApi = () => {
    const { lang } = useParams("/:lang/list-my-property/onboard/:propertyId/basics");
    const [value, setValue] = useStaticDataAtomState();
    const urlBuilder = useUrlBuilder();

    const { isLoading, isError } = useQuery({
        queryKey: [TanstackQueryKey.GetStaticData, lang],
        queryFn: () => oneOnboardingApi.getStaticData(lang).then((res) => res.data),
        onSuccess: setValue,
        onError: (err: AxiosError) => {
            switch (err.status) {
                case 401:
                    window.location.href = urlBuilder.signInUrl();
                    break;
                default:
                    throw err;
            }
        },
    });

    return {
        isLoading: isLoading || value === undefined,
        isError,
    };
};
